function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { ActionType } from "../../enum/ActionType";
/**
 * アクション情報　モデル
 */

var ActionInfoInstanceModel =
/**
 * コンストラクタ
 *
 */
function ActionInfoInstanceModel() {
  _classCallCheck(this, ActionInfoInstanceModel);

  this.ObjectId = "";
  this.ObjectName = "";
  this.ActionType = ActionType.None;
  this.IsOn = true;
  this.IsToggle = true;
  this.MotionName = "";
  this.IsLoop = false;
  this.Scale = 0;
  this.IsDefault = false;
  this.Conditions = [];
};

export { ActionInfoInstanceModel as default };